module.exports = __webpack_public_path__ + "img/taken_crm.25f6c47a.svg";